export default {
  en: {
    download: 'DOWNLOAD',
    print: 'PRINT',
    saveDraft: 'SAVE DRAFT',
    saveSpecialOffer: 'PUBLISH',
    close: 'CLOSE'
  },
  th: {
    download: 'ดาวน์โหลด',
    print: 'พิมพ์',
    saveDraft: 'บันทึกโครงร่าง',
    saveSpecialOffer: 'เผยแพร่',
    close: 'ปิด'
  }
}
